export const BLANKS_LIST = 'Список бланков';
export const SEARCH = 'Поиск по учреждению';
export const ADD_BLANK = 'Создать бланк';
export const DOWNLOAD_ALL = 'Выгрузить все бланки';
export const NO_DATA = 'Нет бланков';
export const NO_DATA_INFO = 'Создайте бланк по кнопке в правом верхнем углу';
export const NO_DATA_ORG = 'Учреждения не найдены';
export const NO_DATA_ORG_INFO = 'Попробуйте икать по другому или сбросьте поиск';
export const RESET_SEARCH = 'Сбросить поиск';
export const ADD_RATING = 'Добавить оценку';
export const EDIT_BLANK = 'Редактировать бланк';
export const DELETE_BLANK = 'Удалить бланк';
export const EXPORT_PDF = 'Выгрузить в .pdf';
export const EXPORT_CSV = 'Выгрузить в .csv';
export const CONFIRMATION_DELETE = 'Подтверждение удаления';
export const DELETE_QUESTION = 'Вы уверены, что хотите удалить данный бланк клиента?';
export const CANCEL = 'Отменить';
export const DELETE = 'Да, удалить';
export const DOWNLOAD_BLANK = 'Выгрузить бланк';
export const DOWNLOAD_QUESTION = 'Вы уверены, что хотите скачать все бланки?';
export const DOWNLOAD = 'Да скачать';
